import React, { useState, useCallback, useEffect, useRef } from 'react';
import { AccessibilityProvider as A11yContextProvider, CONTENT_CLASS } from './AccessibilityContext';
import AccessibilityButton from './AccessibilityButton';
import AccessibilityMenu from './AccessibilityMenu';
import { initShortcuts } from './shortcuts';
import './styles.css';

export default function A11yProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const isOpenRef = useRef(false);

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  const closePanel = useCallback(() => {
    setIsOpen(false);
  }, []);

  const togglePanel = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    const cleanup = initShortcuts({
      onOpenPanel: (e) => {
        e.preventDefault();
        setIsOpen((prev) => !prev);
      },
      onClosePanel: () => {
        if (isOpenRef.current) {
          setIsOpen(false);
        }
      },
      onReset: () => {},
      onHighContrast: () => {},
      onDarkMode: () => {},
    });
    return cleanup;
  }, []);

  return (
    <A11yContextProvider>
      <div className={CONTENT_CLASS}>
        {children}
      </div>
      <AccessibilityButton onClick={togglePanel} isOpen={isOpen} />
      <AccessibilityMenu isOpen={isOpen} onClose={closePanel} />
    </A11yContextProvider>
  );
}
